<template>
  <div class="pc_container app-main-content">
    <div class="app-main-content-section bgfff flex" style="padding: 10px;">
      <div class="flex1">
        <el-row :gutter="20" class="mb10">
          <el-col>
            <el-card class="update-log">
              <div class="">
                <div>
                  <span class="demonstration mr10">游玩日期</span>
                  <el-date-picker v-model="form.date" type="date" placeholder="选择日期" :picker-options="pickerOptionsStart">
                  </el-date-picker>
                </div>
                <div class="flex flex_warp mt10">
                  <div class="tab p10 text_overflow pointer txt_center" :class="check == 0 ? 'checked' : ''"
                    @click="check = 0">全部</div>
                  <div class="tab p10 text_overflow pointer txt_center" :class="check == item.id ? 'checked' : ''"
                    @click="check = item.id" v-for="(item, index) in category" :key="index">
                    {{ item.name }}</div>
                </div>
              </div>
            </el-card>
          </el-col>
        </el-row>

        <el-card class="update-log">
          <div class="t-box">
            <div class="flex_warp flex">
              <div class="f-box pos" v-for="(item, index) in ticket" @click="handleCheck(item)" :key="index"
                :class="item.stock == 0 ? 'unc' : ''">
                <div style="position: absolute;z-index: 2;" class="f-box-1">
                  <div class="bold clamp2 plr10 f18">{{ item.name }}</div>
                  <div class="content flex_between flex plr10">
                    <div>库存：{{ item.stock }}</div>
                    <div class="red bold">￥{{ item.sale_price }}</div>
                  </div>
                </div>
                <img v-if="item.number_people <= 4" :src="require('@/assets/index-icon/' + item.number_people + '.png')"
                  class="bg-icon" alt="">
                <img v-else :src="require('@/assets/index-icon/5.png')" class="bg-icon" alt="">
              </div>
            </div>
          </div>
        </el-card>

        <div>
          <div class="flex mb10 mt10 font_color bold">
            <div class="flex flex_items">
              <span class="flex_shrink">购票人电话：</span><el-input placeholder="请输入" v-model="form.contact_mobile"
                max="11"></el-input>
            </div>
            <div class="flex flex_items ml20">
              <span class="flex_shrink">购票人姓名：</span><el-input placeholder="请输入" max="9"
                v-model="form.contacts"></el-input>
            </div>
            <div class="flex flex_items ml20">
              <span class="flex_shrink">备注：</span><el-input placeholder="请输入" v-model="form.notes" max="200"></el-input>
            </div>
          </div>
          <el-table :data="list" style="width: 100%" height="calc(100vh - 580px)" :header-cell-style="{
            background: '#F3F3F3',
            color: '#1F3349',
            fontSize: '15px',
            fontWeight: 'normal',
          }" :cell-style="{ fontSize: '15px', color: '#666666' }">
            <!-- :index="indexMethod" type="index"-->
            <!-- <el-table-column prop="id" label="序号" align="left" width="110">
            </el-table-column> -->
            <!-- <el-table-column type="index" :index="indexMethod" label="序号" align="center" width="110">
			    </el-table-column> -->
            <el-table-column prop="name" label="票类" align="left" />
            <el-table-column prop="market_price" label="门市价" align="left" />
            <el-table-column prop="sale_price" label="销售价" align="left" />
            <el-table-column prop="name" align="center" label="数量" width="240">
              <template slot-scope="scope">
                <el-input-number v-model="scope.row.ticket_num" :min="1" :precision="0" :step="1"
                  @change="numChange($event, scope.row)" style="width: 100%"></el-input-number>
              </template>
            </el-table-column>
            <el-table-column prop="name" align="left" label="金额">
              <template slot-scope="scope">
                {{ (scope.row.sale_price * scope.row.ticket_num).toFixed(2) }}
              </template>
            </el-table-column>
            <el-table-column prop="name" align="center" label="游客信息" width="160">
              <template slot-scope="scope">
                {{(scope.row.ticket_info ? scope.row.ticket_info.map(r => { return r.name }).join(',') : '')}}
                <i class="el-icon-edit f20 main_color pointer" @click="editUser(scope.$index)"></i>
              </template>
            </el-table-column>
            <el-table-column fixed="right" align="center" label="操作" width="150">
              <template slot-scope="scope">
                <div class="flex flex_items flex_center">
                  <i class="el-icon-delete-solid f20 main_color pointer" @click="del(scope.$index)"></i>
                </div>
              </template>
            </el-table-column>
            <div slot="empty" style="text-align: center;width:100%">
              暂无数据
            </div>

          </el-table>
        </div>
      </div>
      <div class="user-pay">
        <el-card class="update-log" style="height: 100%;">
          <div class="flex_between ptb10"
            style="border-bottom:1px solid rgb(235, 238, 245);border-top: 1px solid rgb(235, 238, 245);">
            <div>应付款 <span class="red">{{ allMoney }}</span></div>
            <div>总数量 <span class="red">{{ allNum }}</span></div>
          </div>
          <div class="pt20 pb20 mb20 ">
            <el-radio-group v-model="form.payment_type" size="medium">
              <el-radio :label="item.key" class="flex flex_items mb20" v-for="item in pay_type">
                <div class="flex flex_items f18 bold">
                  <img :src="item.icon" class="icon"> {{ item.name }}
                </div>
              </el-radio>
            </el-radio-group>
          </div>

          <div class="pos f18 bold" :style="form.payment_type != 'offlinePayment' ? 'opacity:0' : ''">
            <div class="mask" v-if="form.payment_type != 'offlinePayment'"></div>
            <div class="flex flex_items mb20">
              <div class="flex_shrink mr10">实收</div>
              <el-input v-model="payMoney"></el-input>
            </div>
            <div class="flex flex_items mb20">
              <div class="flex_shrink mr10">找零</div>
              <el-input disabled v-model="zhaoling"></el-input>
            </div>
          </div>
          <div class="flex flex_between">
            <el-button style="width: 40%;" @click="clearData">清屏</el-button>
            <el-button style="width: 52%;" type="primary" @click="sellTickets">结账</el-button>
          </div>

        </el-card>
      </div>


      <el-dialog :close-on-press-escape="false" :close-on-click-modal="false" :show-close="true" title="游客信息"
        :visible.sync="popShow" width="1200px" :modal-append-to-body='false' :append-to-body="true">
        <div class="flex">
          <div style="width: 60%;box-sizing: border-box;" class="pr20">
            <el-table :data="popList" style="width: 100%" :header-cell-style="{
              background: '#F3F3F3',
              color: '#1F3349',
              fontSize: '15px',
              fontWeight: 'normal',
            }" :cell-style="{ fontSize: '15px', color: '#666666' }">
              <el-table-column align="center" prop="use_num" label="序号">
                <template slot-scope="scope">
                  <span class="pointer">{{ scope.$index + 1 }}</span>
                </template>
              </el-table-column>
              <el-table-column align="center" prop="name" label="姓名" />
              <el-table-column align="center" prop="mobile" label="电话" />
              <el-table-column align="center" prop="code" label="证件号" />
              <el-table-column align="center" prop="name" label="操作">
                <template slot-scope="scope">
                  <i class="el-icon-delete-solid f20 main_color pointer" @click="popDel(scope.$index)"></i>
                </template>
              </el-table-column>
              <div slot="empty" style="text-align: center;width:100%">
                暂无数据
              </div>
            </el-table>
          </div>
          <div style="border-left: 2px solid #ccc;width: 50%;">
            <div class="txt_center bold c3 f28 mb20">
              身份信息
            </div>
            <div class="">
              <div class="flex flex_items mb20">
                <div class="lebel-items"><span class="red">*</span> 姓名：</div>
                <el-input placeholder="请输入" v-model="itemEditData.name" max="10"></el-input>
              </div>
              <div class="flex flex_items mb20">
                <div class="lebel-items">电话：</div>
                <el-input placeholder="请输入" v-model="itemEditData.mobile" max="11"></el-input>
              </div>
              <div class="flex mb20 flex_items">
                <div class="lebel-items"><span class="red">*</span> 证件类型：</div>
                <el-select v-model="itemEditData.certificate" placeholder="请选择" clearable style="width: 100%">
                  <el-option v-for="(item, index) in tourist_certificate" :key="index" :label="item" :value="index" />
                </el-select>
              </div>
              <div class="flex flex_items">
                <div class="lebel-items">证件号码：</div>
                <el-input placeholder="请输入" v-model="itemEditData.code" max="25"></el-input>
              </div>
            </div>
            <div class="flex mt20 pl20">
              <el-button type="primary" @click="subUser">提交</el-button>
              <el-button @click="resetUser">重置</el-button>
            </div>
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="submitForm">确 定</el-button>
          <el-button @click="cancel">取 消</el-button>
        </div>
      </el-dialog>


      <el-dialog :close-on-press-escape="false" :close-on-click-modal="false" :show-close="true" title="支付"
        :visible.sync="payPop" width="500px" :modal-append-to-body='false' :append-to-body="true">
        <div class="flex flex_items">
          <span class="flex_shrink">支付码：</span>
          <el-input v-model="auth_code" ref="myInput" @keyup.enter.native="payFn(1)"></el-input>
        </div>
        <div class="red mt10">若光标没有指入输入框请手动点击输入框后扫描支付码</div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="auth_code = ''">清空</el-button>
          <el-button type="primary" @click="payFn(1)">结账</el-button>
        </div>
      </el-dialog>

      <el-dialog :close-on-press-escape="false" :close-on-click-modal="false" :show-close="true" title="查询支付状态"
        :visible.sync="nxCheckPop" width="500px" :modal-append-to-body='false' :append-to-body="true">
        <div class="flex flex_items">
          <el-button type="primary" @click="checkPayStatus" :loading="nxCheckPopLoading">
            {{ nxCheckPopLoading ? '查询中...' : '查询支付状态' }}</el-button>
        </div>
        <!-- <div slot="footer" class="dialog-footer">
        <el-button @click="nxCheckPop = false">清空</el-button>
      </div> -->
      </el-dialog>



    </div>
  </div>
</template>
<script>
import leftSlider from '@/components/leftSlider/leftSlider'
import { pageSize } from '@/utils/tool';
import bread from '@/utils/breadList'
import { parseTime } from "@/utils/index"
import { showZzToast, checkPrinterStatus } from '@/utils/index'

export default {
  data() {
    return {
      loading: null,
      payPop: false,
      list: [],
      page: 1,
      orderId: '',

      popShow: false,
      pageSize: pageSize,
      pay: '',
      category: [],
      pay_type: [],
      check: 0,
      ticket: [],
      form: {
        contact_mobile: '',
        contacts: '',
        notes: '',
        date: '',
        tickets: [],
        payment_type: ''
      },
      tourist_certificate: [],
      itemEditData: { //游客信息
        certificate: '',
        code: '',
        mobile: '',
        name: ''
      },
      popList: [],
      payMoney: '',
      zhaoling: '',
      allMoney: 0,
      allNum: 0,
      auth_code: '',
      orderId: '',
      timer: null,
      timeFlag: 0,
      nxCheckPop: false,
      nxCheckPopLoading: false,
      ticketAll: [],//所有票
      pickerOptionsStart: {
        disabledDate(time) {
          // 禁用今天之前的日期（包含今天）
          return time.getTime() < Date.now() - 8.64e7;
        }
      }
    };
  },
  watch: {
    check() {
      if (this.check != 0) {
        this.ticket = this.ticketAll.filter(r => r.ticket_cate_id == this.check)
      } else {
        this.ticket = JSON.parse(JSON.stringify(this.ticketAll))
      }
    },
    payMoney(n) {
      this.zhaoling = n - this.allMoney <= 0 ? 0 : (n - this.allMoney).toFixed(2);
    }
  },
  components: { leftSlider },
  methods: {
    numChange(e) {
      this.checkMoney()
    },
    indexMethod(e) {
      return (e + 1) + this.pageSize * (this.currentPage - 1)
    },
    getInfo() {
      this.api.getUrl(`/api/v1/window/sellTickets/info`, {})
        .then((res) => {
          this.category = res.category;
          this.pay_type = res.pay_type;
          this.tourist_certificate = res.tourist_certificate;
          this.form.payment_type = this.pay_type[0].key;
        });
    },
    getList() {
      this.api.getUrl(`/api/v1/window/sellTickets`, { ticketCategory: this.check == 0 ? '' : this.check })
        .then((res) => {
          this.ticketAll = res.ticket;
          this.ticket = JSON.parse(JSON.stringify(res.ticket))
        });
    },
    handleCheck(item) {
      if (item.stock == 0) return this.$message.error('库存不足')
      if (this.list.filter(r => r.ticket_id == item.id).length > 0) {
        for (let i = 0; i < this.list.length; i++) {
          if (this.list[i].ticket_id == item.id) {
            if (item.stock > 0) {
              this.list[i].ticket_num++;
            } else {
              return this.$message.error('库存不足')
            }
            break;
          }
        }
      } else {
        let items = JSON.parse(JSON.stringify(item))
        let obj = { ticket_num: 1 };
        obj.ticket_id = items.id;
        obj.sale_price = items.sale_price;
        obj.name = items.name;
        obj.market_price = items.market_price;
        obj.number_people = items.number_people;
        this.list.push(obj);
      }
      item.stock--;
      this.checkMoney()
    },
    del(index) {
      this.list.splice(index, 1)
      this.checkMoney()
    },
    editUser(item) {
      this.editItem = this.list[item];
      this.popList = this.editItem.ticket_info ? this.editItem.ticket_info : [];
      this.resetUser()
      this.popShow = true;
    },
    subUser() {
      if (this.editItem.ticket_num * this.editItem.number_people <= this.popList.length) {
        this.$message.error('数量超过了')
        this.resetUser()
        return
      }
      if (!this.itemEditData.name) return this.$message.error('请填写姓名');
      this.popList.push(this.itemEditData)
      this.resetUser()
    },
    submitForm() {
      this.editItem.ticket_info = this.popList;
      console.log(this.editItem);

      this.cancel()
    },
    popDel(i) {
      this.popList.splice(i, 1)
      console.log(this.editItem);

    },
    resetUser() {
      this.itemEditData = { //游客信息
        certificate: Object.keys(this.tourist_certificate)[0],
        code: '',
        mobile: '',
        name: ''
      }
    },
    cancel() {
      this.popShow = false;
    },
    sellTickets() {
      this.api.getUrl('/api/v1/window/printerStatus').then(res => {
        if (res.status != 1) {
          this.$alert('<strong style="color:#ed2222;">打印机没有连接</strong>', '注意！', {
            dangerouslyUseHTMLString: true,
            showClose: false
          });
        } else if (res.status == 1) {
          this.form.tickets = this.list;
          this.auth_code = ''
          if (this.list.length == 0) return this.$message.error('请选择门票')
          if (this.form.date) {
            this.form.date = parseTime(this.form.date, '{y}-{m}-{d}')
          }
          let playTime = new Date(this.form.date).getTime();
          let nowTime = new Date(parseTime(new Date(), '{y}-{m}-{d}')).getTime()
          console.log(playTime, nowTime, nowTime == playTime, 'aaa');
          if (playTime != nowTime) {
            this.$confirm('当前门票游玩时间不是今天确定下单吗?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.sureFn()
            }).catch(() => { });
          } else {
            this.sureFn()
          }
        }
      })
    },
    sureFn() {
      this.loading = this.$loading({
        lock: true,
        background: 'rgba(0, 0, 0, 0.08)',
        text: '正在结算'
      });
      this.orderId = ''
      this.api.postUrl('/api/v1/window/sellTickets/submit', this.form, { loading: true }).then(res => {
        this.orderId = res.id;
        this.loading.close();
        if (this.form.payment_type != 'offlinePayment') {//不是现金都出框
          this.payPop = true;
          this.auth_code = ''
          this.$nextTick(() => {
            this.$refs.myInput.focus(); // ✅ 确保 DOM 渲染完成后再聚焦
          });
        } else {//现金
          this.payFn()
        }
      }, () => {
        this.loading.close();
      })
    },
    payFn(type) {
      this.loading = this.$loading({
        lock: true,
        background: 'rgba(0, 0, 0, 0.08)',
        text: '正在结算'
      });
      this.api.postUrl(`/api/v1/window/sellTickets/pay/${this.orderId}`, { auth_code: this.auth_code }).then(res => {
        if (!type) {
          this.$message.success('支付成功')
          this.loading.close();
          this.popShow = false;
          this.clearData()
        } else { //农信
          this.timeFlag = 0
          this.timer = setInterval(() => {
            this.timeFlag++;
            this.payType() //查询支付状态
          }, 1000);
        }
      }, () => {
        this.loading.close();
        this.$refs.myInput.focus();
        this.auth_code = '';
      })
    },
    payType() {
      this.api.getUrl(`/api/v1/window/sellTickets/getOrderStatus/${this.orderId}`, { auth_code: this.auth_code }).then(res => {
        this.statusFn(res, 1)
      }, () => {
        console.log('支付失败');
        clearInterval(this.timer);
        this.loading.close();
      })
    },
    checkMoney() {
      let m = 0, n = 0
      this.list.map(r => {
        m = ((r.sale_price * r.ticket_num) + m * 1).toFixed(2)
        n += r.ticket_num
      })
      this.allMoney = m;
      this.allNum = n;
    },
    clearData() {
      this.list = [];
      this.allMoney = 0;
      this.allNum = 0;
      this.payMoney = '';
      this.check = 0;
      this.form = {
        contact_mobile: '',
        contacts: '',
        notes: '',
        date: new Date(),
        tickets: [],
        payment_type: ''
      }
    },
    checkPayStatus() {
      this.nxCheckPopLoading = true;
      this.api.getUrl(`/api/v1/window/sellTickets/select/pay/${this.orderId}`, { auth_code: this.auth_code }).then(res => {
        this.statusFn(res, 2)
      })
    },
    statusFn(res, type) {//type-1 系统查询状态 2-手动点击查询状态
      if (type == 2) this.nxCheckPopLoading = false;
      if (res.status == 9) {
        this.$message.error('支付失败，请重新扫码支付')
        clearInterval(this.timer);
        this.auth_code = '';
        this.loading.close();
        this.$refs.myInput.focus();
        this.nxCheckPop = false;
      } else if (res.status == 1) {
        this.$message.success('支付成功')
        clearInterval(this.timer);
        this.payPop = false;
        this.popShow = false;
        this.nxCheckPop = false;
        this.loading.close();
        this.clearData()
      } else if (res.status == 0) {//待支付
        if (type == 1) {
          if (this.timeFlag == showZzToast) {
            this.nxCheckPop = true;//打开自助查询弹窗
          }
        } else {
          this.$message('正在支付，请稍后')
        }
      }
    },
    clearCode() {
      this.auth_code = '';
      this.$refs.myInput.focus();
    }
  },
  created() {
    this.check = 0;
    this.form.date = new Date();
    this.getInfo();
    this.getList()
  },
};
</script>
<style scoped>
.unc {
  background: #eee;
}

.list-items {
  width: 266px;
  height: 150px;
  background: #F5F7FA;
  border-radius: 8px 8px 8px 8px;
  box-sizing: border-box;
}


.page_title {
  margin-bottom: 24px;
}

.t-box {
  min-height: 220px;
  max-height: 220px;
  /* border: 1px solid #ccc; */
  overflow-y: auto;
  border-radius: 5px;
}

.f-box {
  border: 2px solid #aaa;
  border-radius: 5px;
  padding: 10px 0;
  width: 200px;
  height: 100px;
  margin-right: 20px;
  display: inline-flex;

  /* height: 100px; */
  position: relative;
  cursor: pointer;
  box-sizing: border-box;
  margin-bottom: 10px;
}

.f-box-1 {
  flex-direction: column;
  width: 100%;
  height: 100%;
}

.f-box .content {
  position: absolute;
  bottom: 0;
  margin-bottom: 10px;
  width: 100%;
}

.user-pay {
  width: 320px;
  flex-shrink: 0;
  margin-left: 20px;
  height: 100%;
  height: calc(100vh - 120px);
}



.tab {
  width: 100px;
  margin-right: 10px;
  border: 2px solid #ccc;
  border-radius: 5px;
  color: #1a1a1a;
}

.tab.checked {
  border: 2px solid #409EFF;
  background: #409EFF;
  color: #fff;
}

.lebel-items {
  width: 100px;
  text-align: right;
  flex-shrink: 0;
}

.mask {
  position: absolute;
  z-index: 2;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  /* background: #eee; */
}

.bg-icon {
  position: absolute;
  width: 35%;
  display: block;
  right: 0;
  top: 40%;
  transform: translate(0, -50%);
  z-index: 0;
}
</style>